import { TemplatePage } from './types';

const live_streaming_interior_design_theme: TemplatePage = {
  header: {
    color: '#C5D7E3',
    icon: 'images/video-templates/architecture_design.jpg',
    title: 'Live Stream Templates — Interior Design Theme',
    title_meta: 'Free Live Stream Overlay Templates — Interior Design Theme',
    description_meta:
      'Push your creative boundaries with Wave.video’s editable interior-design-themed overlay templates for live streaming.',
    description:
      'Push your creative boundaries with our collection of editable interior-design-themed overlay templates for live' +
      ' streaming. Create eye-catching branded thumbnails, lower thirds, intros & outros, and overlays for your live' +
      ' streams with minimum effort'
  },
  footer: {
    category: 'Live Stream Interior Design Theme',
    description:
      'Wave.video’s extensive collection of easy-to-edit templates for multiple industries and occasions will help you make' +
      ' more pro-looking and visually appealing live streams. Grab and hold the attention of your online audience with on-brand' +
      ' overlays, intros, outros, thumbnails, and lower thirds without spending vast sums of money on hiring expensive video' +
      ' editors. Step up your live streaming game and immediately reap the rewards of your efforts!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Stream Templates — Interior Design Theme',
      search: { name: 'InteriorDesignTheme', tags: 'InteriorDesignTheme' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_interior_design_theme;
